'use strict';
const formatModel = require('js/lib/formatModel');
const formatCommunityModel = require('js/lib/formatCommunityModel');
var Model = require('js/lib/model');

var Search = Model.extend();

/**
 * Parse api endpoint data
 */
Search.prototype.parse = function(attributes) {
  const snippets = attributes.highlight && attributes.highlight.body ? attributes.highlight.body : null;
  const users = (this.getCachedData('users', {}, true) || []).map(model => model.attributes);
  const model = formatModel({ model: {...(attributes._source || attributes), snippets }, users });
  const cachedGroup = this.getCachedData('groups', model.groupId);

  return formatCommunityModel(model, cachedGroup ? cachedGroup.attributes : null);
};

module.exports = Search;



// WEBPACK FOOTER //
// ./app/assets/js/models/search.js